import { api } from "../../api/client.ts";
import type { Me, MentionsEmail } from "../../api/types.gen.ts";
import { t } from "../../i18n/index.ts";
import { useAction } from "../../lib/resource.ts";
import { me } from "../../lib/state.ts";
import { Field } from "../../ui/form.tsx";
import { Segmented } from "../../ui/Segmented.tsx";

const CHOICES: readonly MentionsEmail[] = ["immediately", "daily", "off"];

/** Emails about mentions (right away, once a day, never): saved as it's picked (no Save); back to the last if that fails. */
export function MentionsEmailField() {
  const chosen = (me.value as Me).mentions_email;
  const [pick] = useAction(async (v: MentionsEmail) => {
    me.value = { ...(me.value as Me), mentions_email: v };
    try {
      const saved = await api.patch<Me>("/me", { mentions_email: v });
      me.value = { ...(me.value as Me), mentions_email: saved.mentions_email };
    } catch (e) {
      me.value = { ...(me.value as Me), mentions_email: chosen };
      throw e;
    }
  });
  return (
    <Field
      label={t("profile.mentionsEmail")}
      hint={t("profile.mentionsEmail.hint")}
      group={true}
      anchor="mentions-email"
    >
      <Segmented
        label={t("profile.mentionsEmail")}
        value={chosen}
        onValue={(v) => v !== chosen && pick(v)}
        options={CHOICES.map((v) => ({ value: v, label: t(`profile.mentionsEmail.${v}`) }))}
        class="self-start"
      />
    </Field>
  );
}
